module.exports = __webpack_public_path__ + "media/images/payment-mir-c1e50da8eff4a8899bd670a5d3f95e2c.png";